var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminNextIframe',{attrs:{"path":"/integrations/mcp","full-view":false},on:{"back":_vm.onBack},scopedSlots:_vm._u([{key:"fallback",fn:function(){return [_c('p',{staticClass:"mcp-connector-empty"},[_vm._v(" "+_vm._s(_vm.$t('account.mcp_connector.missing_next_admin'))+" ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }